import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NotificationService } from '../shared/notification.service';
import { VariantBattery, VehicleMake, VehicleModel, VehicleVariant } from '../models/battery';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BatteryService {

  apiUrl = 'v1/battery/';

  constructor(private http: HttpClient, private notification: NotificationService) { }

  public getVehicleMakes() {
    return this.http.get<VehicleMake[]>(environment.ApiUrl() + this.apiUrl + `vehicle/make`);
  }

  public getVehicleModels(makeId: number) {
    return this.http.get<VehicleModel[]>(environment.ApiUrl() + this.apiUrl + `vehicle/make/${makeId}/model`);
  }

  public getVehicleVariants(modelId: number) {
    return this.http.get<VehicleVariant[]>(environment.ApiUrl() + this.apiUrl + `vehicle/model/${modelId}/variant`);
  }

  public getVariantBattery(variantId: number) {
    return this.http.get<VariantBattery[]>(environment.ApiUrl() + this.apiUrl + `variant/${variantId}/battery`);
  }
  

}
